<template>
  <div v-if="showList && tokenListData" class="switch__body" style="border: none">
    <div v-if="tokenListData.list.length === 0">
      {{ $t(`${namespace}.emptyToken`) }}
    </div>
    <div v-else>
      <div v-for="item in tokenListData.list" :key="item.token_id" class="token_list_item">
        <div class="token_list_item_tokenId">
          <div :class="{ token_list_item_tokenStatus: true, active: item.enabled }"></div>
          {{ item.token_id }}
        </div>
        <div class="token_list_item_viewToken">
          <div class="token_list_item_viewToken_value">{{ item.token_value }}</div>
          <div
            @click="
              () => {
                onIconClick(item);
              }
            "
          >
            <img src="@/assets/icons/viewToken.svg" alt="" class="token_list_item_viewToken_icon" />
          </div>
        </div>
        <div class="token_list_item_oprate">
          <a
            v-if="item.enabled"
            class="text--link accent--text"
            @click="
              () => {
                handleTokenSwitch(item);
              }
            "
            >{{ $t(`${namespace}.disable`) }}</a
          >
          <a
            v-else
            class="text--link accent--text"
            @click="
              () => {
                handleTokenSwitch(item);
              }
            "
            >{{ $t(`${namespace}.enable`) }}</a
          >
        </div>
      </div>
    </div>
    <FullTokenDialog
      :visible="showFullTokenDialog"
      @close="handleCloseFullTokenDialog"
      :fullToken="fullToken"
    ></FullTokenDialog>
    <UpdateTokenDialog
      :visible="showUpdateTokenDialog"
      @close="handleCloseUpdateTokenDialog"
      :curToken="curToken"
      @handleSubmit="handleUpdateSubmit"
    ></UpdateTokenDialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import companyService from '@/services/company'
import FullTokenDialog from './FullTokenDialog'
import UpdateTokenDialog from './UpdateTokenDialog'

export default {
  name: 'TokenList',
  props: {
    tokenListData: {
      type: Object,
      default: () => {}
    },
    showList: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FullTokenDialog,
    UpdateTokenDialog
  },
  created () {
    this.$emit('getTokenListData')
  },
  data () {
    return {
      namespace: 'Components.AllowApiToken.tokenList',
      showFullTokenDialog: false,
      showUpdateTokenDialog: false,
      fullToken: '',
      curToken: {}
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    async onIconClick (item) {
      try {
        const { data: res } = await companyService.getTokenDetail({ tokenId: item.token_id })
        this.fullToken = res.data
        this.showFullTokenDialog = true
      } catch (e) {
        this.showAlert({ type: 'error', message: e.errmsg || this.$t(`Components.AllowApiToken.error`) })
      }
    },
    handleCloseFullTokenDialog () {
      this.showFullTokenDialog = false
    },
    handleCloseUpdateTokenDialog () {
      this.showUpdateTokenDialog = false
    },
    handleTokenSwitch (item) {
      this.curToken = item
      this.showUpdateTokenDialog = true
    },
    handleUpdateSubmit (item) {
      this.$emit('getTokenListData')
    }
  }
}
</script>
<style lang="scss" scoped>
.switch__body {
  border-bottom: none;
  border-top: 1px solid $gray-2;
  background-color: #fff;
  padding: 16px;

  &.switch__body--no-border {
    border: none;
  }
}
.token_list_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0px 16px;
  .token_list_item_tokenId {
    flex: 1;
    display: flex;
    align-items: center;
    .token_list_item_tokenStatus {
      background-image: linear-gradient(135deg, #d8080f, #aa0419);
      width: 14px;
      height: 14px;
      border-radius: 50%;
      margin-right: 8px;
      &.active {
        background-image: linear-gradient(135deg, #b4ec51, #2dcc70);
      }
    }
  }
  .token_list_item_viewToken {
    flex: 1;
    display: flex;
    align-items: center;
    .token_list_item_viewToken_value {
      min-width: 80px;
    }
    .token_list_item_viewToken_icon {
      display: flex;
      align-items: center;
      margin-left: 4px;
      cursor: pointer;
      width: 18px;
      height: 18px;
    }
  }
  .token_list_item_oprate {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }
}
</style>
